<div
  class="field"
  [class.field--error]="isFieldInvalid(field.key)"
  [class.field--custom]="!!customFieldComponent"
  [class.field--modal]="layout === 'modal'"
  [formGroup]="form"
  >
  <label
    [for]="field.key"
    class="field__label"
    >
    {{ field.label }}
    @if (field.required) {
      <span class="field__required">*</span>
    }
    @if (field.tooltip) {
      <i
        class="pi pi-info-circle field__hint-icon"
        [pTooltip]="field.tooltip"
        tooltipPosition="top"
      ></i>
    }
    @if (field.labelActionIcon) {
      <i
        [class]="'pi ' + field.labelActionIcon + ' field__action-icon'"
        (click)="field.labelAction ? field.labelAction(form) : null; $event.stopPropagation()"
        [pTooltip]="field.labelActionTooltip || 'Edytuj słownik'"
        tooltipPosition="top"
      ></i>
    }
  </label>

  @if (field.topContent) {
    <div class="field__top-content" [innerHTML]="field.topContent"></div>
  }

  @if (field.type === 'text') {
    <input
      pInputText
      [id]="field.key"
      [formControlName]="field.key"
      [placeholder]="field.placeholder || ''"
      [readonly]="field.readonly || false"
      (blur)="triggerOnBlur()"
      class="w-full"
      />
  }

  @if (field.type === 'email') {
    <input
      pInputText
      type="email"
      [id]="field.key"
      [formControlName]="field.key"
      [placeholder]="field.placeholder || ''"
      [readonly]="field.readonly || false"
      (blur)="triggerOnBlur()"
      class="w-full"
      />
  }

  @if (field.type === 'url') {
    <div>
      <input
        pInputText
        type="url"
        [id]="field.key"
        [formControlName]="field.key"
        [placeholder]="field.placeholder || 'https://example.com'"
        [readonly]="field.readonly || false"
        class="w-full"
        />
    </div>
  }

  @if (field.type === 'number') {
    <p-inputNumber
      [formControlName]="field.key"
      [placeholder]="field.placeholder || ''"
      [readonly]="field.readonly || false"
      [step]="field.step || 1"
      [min]="getNumberValue(field.min)"
      [max]="getNumberValue(field.max)"
      [minFractionDigits]="field.minFractionDigits !== undefined ? field.minFractionDigits : 0"
      [maxFractionDigits]="field.maxFractionDigits !== undefined ? field.maxFractionDigits : 5"
      locale="en-US"
      (onBlur)="triggerOnBlur()"
      (keydown)="handleNumberKeyDown($event)"
      [inputStyleClass]="'w-full'"
      class="w-full"
      />
  }

  @if (field.type === 'currency') {
    <p-inputNumber
      [formControlName]="field.key"
      [placeholder]="field.placeholder || ''"
      [readonly]="field.readonly || false"
      mode="currency"
      currency="PLN"
      locale="pl-PL"
      [minFractionDigits]="field.minFractionDigits !== undefined ? field.minFractionDigits : 0"
      [maxFractionDigits]="field.maxFractionDigits !== undefined ? field.maxFractionDigits : 2"
      [min]="getNumberValue(field.min)"
      [max]="getNumberValue(field.max)"
      (onBlur)="triggerOnBlur()"
      (keydown)="handleNumberKeyDown($event)"
      [inputStyleClass]="'w-full'"
      class="w-full"
      />
  }

  @if (field.type === 'textarea') {
    <textarea
      pInputTextarea
      [id]="field.key"
      [formControlName]="field.key"
      [placeholder]="field.placeholder || ''"
      [readonly]="field.readonly || false"
      [rows]="field.rows || 3"
      (blur)="triggerOnBlur()"
      class="w-full textarea-field"
      [autoResize]="true"
    ></textarea>
  }

  @if (field.type === 'select') {
    <p-select
      [formControlName]="field.key"
      [options]="getSelectOptions()"
      optionLabel="label"
      optionValue="value"
      [placeholder]="field.placeholder || 'Wybierz...'"
      [filter]="field.filter === true"
      [showClear]="!field.required"
      [appendTo]="'body'"
      class="w-full"
      />
  }

  @if (field.type === 'date') {
    <p-datepicker
      [formControlName]="field.key"
      [id]="field.key"
      [placeholder]="field.placeholder || 'RRRR-MM-DD'"
      [showIcon]="true"
      [showOnFocus]="true"
      [iconDisplay]="'input'"
      [appendTo]="'body'"
      [dateFormat]="'yy-mm-dd'"
      [showOtherMonths]="true"
      [selectOtherMonths]="true"
      (input)="onDateInput($event)"
      class="w-full"
      />
  }

  @if (field.type === 'switch') {
    <p-toggleSwitch [formControlName]="field.key" />
  }

  @if (field.type === 'button') {
    <div class="field__button-row">
      <p-button
        [id]="field.key"
        [severity]="field.severity || 'secondary'"
        [outlined]="field.severity ? false : true"
        [size]="field.size"
        [pTooltip]="field.tooltip"
        tooltipPosition="top"
        (onClick)="field.action ? field.action(form) : null"
        class="form-field-button"
        [class.w-full]="field.severity === 'primary'"
      >
        <span
          [class]="field.placeholder || (field.severity === 'primary' ? 'pi pi-map-marker' : 'pi pi-pencil')"
          aria-hidden="true"
        ></span>
        <span>{{ field.buttonLabel || field.label }}</span>
      </p-button>
    </div>
  }

  @if (customFieldComponent; as component) {
    <ng-container *ngComponentOutlet="component; inputs: customFieldInputs"></ng-container>
  }

  @if (field.hint && field.type !== 'switch') {
    <small
      class="field__hint"
      >
      {{ field.hint }}
    </small>
  }

  @if (field.helpText) {
    <small class="field__help-text">
      <i class="pi pi-info-circle field__help-icon"></i>
      {{ field.helpText }}
    </small>
  }

  @if (isFieldInvalid(field.key)) {
    <small class="field__error">
      {{ getFieldError(field.key) }}
    </small>
  }
</div>
